// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__3_q6s","content":"Consent_content__2V7hW","footer":"Consent_footer__3F8bd"};